import { render } from "./SvgIcon.vue?vue&type=template&id=c82b2728"
import script from "./SvgIcon.vue?vue&type=script&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script